function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var SvgIconHome = function SvgIconHome(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 18,
    viewBox: "0 0 18 18",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, /*#__PURE__*/React.createElement("path", {
    "data-name": "\\uD328\\uC2A4 49",
    d: "M54.384 45.08a.852.852 0 0 1-.682.379.827.827 0 0 1-.577-.243l-.324-.286v6.893A1.982 1.982 0 0 1 51 53.945h-2.7a.986.986 0 0 1-.9-1.058v-4.242a.992.992 0 0 0-.9-1.064h-1.8a.988.988 0 0 0-.9 1.064v4.243a.99.99 0 0 1-.9 1.058h-2.7a1.982 1.982 0 0 1-1.8-2.121v-6.894l-.324.317a.816.816 0 0 1-1.271-.137 1.194 1.194 0 0 1 .118-1.493l7-6.936a2.3 2.3 0 0 1 3.371 0l7 6.936a1.189 1.189 0 0 1 .106 1.462",
    transform: "translate(-36.597 -35.945)",
    style: {
      fill: "#363b45"
    }
  }));
};

var ForwardRef = React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgIconHome, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/icon_home.55ef4de3.svg";
export { ForwardRef as ReactComponent };